module.exports = __webpack_public_path__ + "media/dancing.48c6f091.mp4";